import React from 'react';
import { css } from '../styled-system/css/index';
import { Link } from 'react-router-dom';
import SEO, { SITE_URL } from '../components/SEO';
import useCatalogProducts from '../hooks/useCatalogProducts';

const pageStyle = css({
  maxW: '1100px',
  m: '40px auto',
  p: '0 20px',
});

const headerStyle = css({
  color: '#111827',
  mb: '16px',
});

const gridStyle = css({
  display: 'grid',
  gap: '20px',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
});

const cardStyle = css({
  display: 'block',
  border: '1px solid #e5e7eb',
  bg: '#fff',
  borderRadius: '10px',
  textDecoration: 'none',
  color: '#111827',
  overflow: 'hidden',
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
});

const imgStyle = css({
  w: '100%',
  h: '160px',
  objectFit: 'contain',
  bg: '#f8fafc',
});

const bodyStyle = css({
  p: '12px 14px',
});

const nameStyle = css({
  m: '0 0 8px',
  fontSize: '1.05rem',
});

const priceStyle = css({
  color: '#197bbd',
  fontWeight: 700,
});

const Products = () => {
  const products = useCatalogProducts();
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Server Rack Blanking Panels and Airflow Products',
    url: `${SITE_URL}/products`,
    description:
      'Browse EziBlank server rack blanking panels, brush panels, magnetic brush panels, and EziWall airflow management products.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: products.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `${SITE_URL}/products/${product.slug}`,
        name: product.description,
      })),
    },
  };

  return (
    <div className={pageStyle}>
      <SEO
        title="Server Rack Blanking Panels, Brush Panels and EziWall Products | EZIBLANK USA"
        description="Browse 19 inch and 23 inch server rack blanking panels, rack brush panels, magnetic brush panels, and EziWall airflow barriers from EZIBLANK USA."
        path="/products"
        jsonLd={jsonLd}
      />
      <h1 className={headerStyle}>Server Rack Blanking Panels and Airflow Products</h1>
      <div className={gridStyle}>
        {products.map((p) => {
          const priceText = typeof p.price === 'number' ? `$${p.price.toFixed(2)}` : '';
          return (
            <Link className={cardStyle} key={p.id} to={`/products/${p.slug}`}>
              <img className={imgStyle} src={p.image} alt={p.name} />
              <div className={bodyStyle}>
                <h3 className={nameStyle}>{p.description}</h3>
                <div className={priceStyle}>PRICE: {priceText}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Products;
